import { useSelector } from 'react-redux';

export default function PermissionCheck() {
  const selectedContextPermissions = useSelector(
    store => store.user.selectedBusinessContext?.permissions
  );

  const selectedTenantId = useSelector(store => store.user.selectedTenant.tenantId);

  const selectedBusinessContextId = useSelector(store =>
    store.user.selectedBusinessContext.businessContextId);

  const hasPermission = permission =>
    selectedContextPermissions?.includes(permission);

  const isAdminUser = () => selectedTenantId === '0' && selectedBusinessContextId === 'Default';

  return {
    hasPermission,
    isAdminUser
  };
}
